import PropTypes from "prop-types";
import feedbackTimescaleOptionsType from "./feedbackTimescaleOptionsType";

export default PropTypes.shape({
  interviewComments: PropTypes.string.isRequired,
  interviewStages: PropTypes.number.isRequired,
  feedbackTimescaleId: PropTypes.number.isRequired,
  feedbackTimescaleOptions: feedbackTimescaleOptionsType.isRequired,
  cvLimitPerRecruiter: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
});
